// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"296":"ea88be26","4814":"70cfe1b1"}[chunkId] || chunkId) + "." + {"296":"bdb70bd8a3f966ae","4032":"859104f5b4d89ef0","4814":"eeaf60e04cddc1b3","7229":"afd4c4edbed76b59","9464":"b013745f4df32685"}[chunkId] + ".js";
};